module.exports = __webpack_public_path__ + "img/16.ab58beb2.webp";